import { fetchCustomPaymentMethods } from "./fetch-custom-payment-methods";
import { createCustomPaymentMethod } from "./create-custom-payment-method";
import { updateCustomPaymentMethod } from "./update-custom-payment-method";

export const customPaymentMethodRepo = {
  get: fetchCustomPaymentMethods,
  create: createCustomPaymentMethod,
  update: updateCustomPaymentMethod,
};
